import moment from "moment";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { Card, CardContent, CardHeader, Menu, MenuItem, Tooltip } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SearchIcon from "@material-ui/icons/Search";

//import custom components
import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import GenericButton from "components/Buttons/GenericButton";
import FormSelect from "components/FormFields/FormSelect";
import { opportunitiesExportReportMap } from "mappers/OpportunityMap";
import { getDataSetByNameAction } from "redux/actions/datasetsAction";
import getReportAction from "redux/actions/reportsAction";
import { DATASET, OPERATIONS, PAGINATION, REPORT_CONSTS, REPORT_FILE_NAME, USER_TYPE } from "utils/const";
import { getDatasetStateByName } from "utils/datasets";
import { checkOperationPermission } from "utils/permission";

const useStylesGeneric = makeStyles(componentStylesGeneric);
const useResponsiveStyles = makeStyles((theme) => ({
  headerActionsItem: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: "auto",
    },
  },
  fullWidthOnMobile: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  actionsContainer: {
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
}));

function FilterSection(props) {
  const classes = useStylesGeneric();
  const responsiveClasses = useResponsiveStyles();
  const history = useHistory();

  const {
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    if (props.datasetsState[DATASET.PROVINCES] === undefined || props.datasetsState[DATASET.PROVINCES]?.length === 0) {
      props.getDataSetByName(DATASET.PROVINCES);
    }
    if (
      props.datasetsState[DATASET.OPPORTUNITY_TYPE] === undefined ||
      props.datasetsState[DATASET.OPPORTUNITY_TYPE]?.length === 0
    ) {
      props.getDataSetByName(DATASET.OPPORTUNITY_TYPE);
    }
    if (
      props.datasetsState[DATASET.OPPORTUNITY_STATE] === undefined ||
      props.datasetsState[DATASET.OPPORTUNITY_STATE]?.length === 0
    ) {
      props.getDataSetByName(DATASET.OPPORTUNITY_STATE);
    }
    if (
      props.datasetsState[DATASET.PROFESSIONAL_CATEGORY] === undefined ||
      props.datasetsState[DATASET.PROFESSIONAL_CATEGORY]?.length === 0
    ) {
      props.getDataSetByName(DATASET.PROFESSIONAL_CATEGORY);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [exportMenuAnchorEl, setExportMenuAnchorEl] = useState(null);
  const exportMenuOpen = Boolean(exportMenuAnchorEl);

  const handleOpenExportMenu = (event) => {
    setExportMenuAnchorEl(event.currentTarget);
  };

  const handleCloseExportMenu = () => {
    setExportMenuAnchorEl(null);
  };

  const handleExportReport = (extension) => {
    handleCloseExportMenu();

    const baseFilter = props.getFilterForExport?.() || getValues();
    const filterToExport = {
      ...baseFilter,
      pageIndex: PAGINATION.FIRST_PAGE,
      pageSize: REPORT_CONSTS.MAX_RESULTS,
    };

    props.getReport(
      opportunitiesExportReportMap(filterToExport),
      REPORT_FILE_NAME.OPPORTUNITIES_SEARCH_RESULTS + moment().format("YYYYMMDDHHmm") + extension
    );
  };

  const totalRecords = props.opportunitiesState?.total_records ?? 0;
  const canExport = totalRecords >= 1 && totalRecords <= REPORT_CONSTS.MAX_RESULTS;

  const onSubmit = (data) => {
    props.onSubmit?.(data);
  };

  return (
    <Card classes={{ root: classes.cardRoot }}>
      <CardHeader
        classes={{
          action: classes.cardHeaderAction,
          title: classes.cardHeader,
        }}
        title={
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm="auto">
              <Box>Pesquisa de Ofertas </Box>
            </Grid>
            <Grid item xs={12} sm="auto" className={responsiveClasses.headerActionsItem}>
              {checkOperationPermission(props.authState.operationsList, OPERATIONS.OPPORTUNITY_CREATE_BUTTON) && (
                <GenericButton
                  typeSubmit={false}
                  color="tertiary"
                  className={responsiveClasses.fullWidthOnMobile}
                  onClick={() => {
                    history.push("/admin/opportunities-create");
                  }}
                >
                  Criar Oferta
                </GenericButton>
              )}
            </Grid>
          </Grid>
        }
      ></CardHeader>
      <CardContent>
        <Box>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container classes={{ root: classes.containerPadding }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormGroup>
                  <FormLabel classes={{ root: classes.filterLabel }}>Nº Oferta</FormLabel>
                  <Controller
                    name="reference"
                    control={control}
                    defaultValue=""
                    component={Box}
                    render={({ field: { onChange, name, value } }) => (
                      <OutlinedInput
                        name={name}
                        value={value}
                        onChange={(e) => {
                          onChange(e.target.value);
                        }}
                        fullWidth
                        autoComplete="off"
                        type="text"
                        placeholder="Pesquisar"
                        endAdornment={
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        }
                      />
                    )}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={3} md={2}>
                <FormGroup>
                  <FormLabel classes={{ root: classes.filterLabel }}>Tipo de Oferta</FormLabel>
                  <FormSelect
                    control={control}
                    fieldName="opportunityType"
                    selectOptions={getDatasetStateByName(props, DATASET.OPPORTUNITY_TYPE)}
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    classes={classes}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={3} md={2}>
                <FormGroup>
                  <FormLabel classes={{ root: classes.filterLabel }}>Província</FormLabel>
                  <FormSelect
                    control={control}
                    fieldName="province"
                    selectOptions={getDatasetStateByName(props, DATASET.PROVINCES)}
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    classes={classes}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormGroup>
                  <FormLabel classes={{ root: classes.filterLabel }}>Área Profissional</FormLabel>
                  <FormSelect
                    control={control}
                    fieldName="professionalCategory"
                    selectOptions={getDatasetStateByName(props, DATASET.PROFESSIONAL_CATEGORY)}
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    classes={classes}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormGroup>
                  <FormLabel classes={{ root: classes.filterLabel }}>Pesquisa (título/descrição)</FormLabel>
                  <Controller
                    name="searchText"
                    control={control}
                    defaultValue=""
                    component={Box}
                    render={({ field: { onChange, name, value } }) => (
                      <OutlinedInput
                        name={name}
                        value={value}
                        onChange={(e) => {
                          onChange(e.target.value);
                        }}
                        fullWidth
                        autoComplete="off"
                        type="text"
                        placeholder="Pesquisar"
                        endAdornment={
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        }
                      />
                    )}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <FormGroup>
                  <FormLabel classes={{ root: classes.filterLabel }}>Estado</FormLabel>
                  <FormSelect
                    control={control}
                    fieldName="opportunityState"
                    selectOptions={getDatasetStateByName(props, DATASET.OPPORTUNITY_STATE)}
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    classes={classes}
                  />
                </FormGroup>
                {/* Botões de Pesquisa */}
              </Grid>
              <Grid item xs={12} md={12} classes={{ root: classes.textAlignRight }}>
                <Grid container spacing={2} className={responsiveClasses.actionsContainer}>
                  {props.authState.personalInformation?.userType === USER_TYPE.COLLECTIVE && (
                    <Grid item xs={12} sm="auto">
                      <Tooltip
                        title={
                          canExport
                            ? ""
                            : `Limite mínimo de 1 e máximo de ${REPORT_CONSTS.MAX_RESULTS} resultados para exportar relatório`
                        }
                        placement="top"
                      >
                        <span>
                          <GenericButton
                            typeSubmit={false}
                            color="primary"
                            onClick={handleOpenExportMenu}
                            className={responsiveClasses.fullWidthOnMobile}
                            disabled={!canExport || props.opportunitiesState?.searchOpportunities_loading}
                          >
                            Exportar <KeyboardArrowDownIcon />
                          </GenericButton>
                          <Menu
                            anchorEl={exportMenuAnchorEl}
                            open={exportMenuOpen}
                            onClose={handleCloseExportMenu}
                            keepMounted
                          >
                            <MenuItem onClick={() => handleExportReport(REPORT_FILE_NAME.PDF_EXTENSION)}>PDF</MenuItem>
                            <MenuItem onClick={() => handleExportReport(REPORT_FILE_NAME.EXCEL_EXTENSION)}>Excel</MenuItem>
                          </Menu>
                        </span>
                      </Tooltip>
                    </Grid>
                  )}
                  <Grid item xs={12} sm="auto">
                    <GenericButton
                      typeSubmit={false}
                      color="ghost"
                      className={responsiveClasses.fullWidthOnMobile}
                      onClick={() => {
                        props.onReset?.();
                      }}
                    >
                      Limpar Filtros
                    </GenericButton>
                  </Grid>
                  <Grid item xs={12} sm="auto">
                    <GenericButton
                      typeSubmit={true}
                      color="primary"
                      className={responsiveClasses.fullWidthOnMobile}
                      loading={props.opportunitiesState?.searchOpportunities_loading}
                    >
                      Pesquisar
                    </GenericButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Box>
      </CardContent>
    </Card>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  getDataSetByName: (data, parentKeyValue) => dispatch(getDataSetByNameAction(data, parentKeyValue)),
  getReport: (data, reportFileName) => dispatch(getReportAction(data, reportFileName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterSection);
